import React, { Component } from 'react';
import CardView from './cardTypes/CardView/index';
import CardHighlight from './cardTypes/CardHighlight/index';
import CardTalents from './cardTypes/CardTalents/index';
import CardMatches from '../../mundial/RibbonTypes/CardsTypesMundial/MatchesCard/index';
import CardPlayer from '../../mundial/RibbonTypes/CardsTypesMundial/PlayersCard/index';
import FakeLink from '../FakeLink';
import focusSetting from '../Focus/settings';
import CardHelper from './helpers';
import './card.scss';
import {
    CLASSIC,
    HIGHLIGHT,
    PREMIUM,
    TALENTS,
    RECORDINGS,
    MOREPOPULAR,
    MORETOP,
    INFINITE,
    LIVECHANNEL,
    VOID,
    MUNDIALSOCCERMATCHER,
    MUNDIALPLAYERS,
} from '../RibbonNew/constants';
import CardRecording from './cardTypes/CardRecording';
import CardPremium from './cardTypes/CardPremium';
import CardMorePopular from './cardTypes/CardMorePopular';
import CardTop from './cardTypes/CardTop';
import CardInfinite from './cardTypes/CardInfinite';
import CardLiveChannel from './cardTypes/CardLiveChannel';
import CardVoid from './cardTypes/CardVoid';
import Utils, {getNavDataNodeByCode, getNavDataNodeById, getContentAvailability} from '../../utils/Utils';
import { MODAL_RECORD_SERIES_CONTENT, MODAL_TALENT_CONTENTS } from '../../actions/modal';
import { changeDateToUserRegion } from 'src/mundial/requests/utils';
import store from '../../store';
import { sendGAEvent } from 'src/utils/analytics';
import {GA4} from 'src/utils/trackers/GA4';
import {CONTENT_TYPE_MOVIE, CONTENT_TYPE_SERIE, CONTENT_TYPE_TV,
        CONTENT_SECTION_ADDON, CONTENT_SECTION_SUBCATEGORY, CONTENT_SECTION_ADDON_SUBCATEGORY, CONTENT_SECTION_SUBCATEGORY_TALEN, CONTENT_SECTION_VCARD} from 'src/utils/trackers/GA4Constants';
class Card extends Component {
    constructor(props) {
        super(props);
        this.getLinkEnvelope = this.getLinkEnvelope.bind(this);
        this.infiniteCardEnvelope = this.infiniteCardEnvelope.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.init = this.init.bind(this);
        this.getClassNumberTop = this.getClassNumberTop.bind(this);

        this.init(props);
        this.state = {
            positionInfinite: props.positionInfinite,
            showActions: false,
        };
    }

    init(props) {
        /**
         * Por el momento el onclick se usa sólo para card tipo livechannel y es en conjunto con
         * el typeRender='a' (ver RibbonLiveChannel)
         */
        this.onClick = props.onClick ? props.onClick : null;
        this.typeRender = props.typeRender;
        this.id = props.id;
        this.focusUp = props.focusUp;
        this.focusRight = props.focusRight;
        this.focusLeft = props.focusLeft;
        this.focusHandler = props.focusHandler;
        this.data = props.data || {};
        this.data.api = props.api;
        this.keyUpHandler = props.keyUpHandler;
        this.keyDownHandler = props.keyDownHandler;
        this.deleteAction = props.deleteAction;
        this.focusClassName = props.focusable ? focusSetting.className : focusSetting.nonfocusable;
        this.onLoadHandler = props.onLoadHandler;
        this.group_name = props.group_name;
        const hasZoomEfectActive = Utils.getApaMetadataKey(
            'aaf_effects_ribbons',
            '{"enable":false}',
            'enable'
        );
        this.zoomEfectClassName = hasZoomEfectActive ? 'link-zoom' : '';
        this.changeFontWeight = window.location.pathname.includes('vcardmatch');

        if (this.props.type !== VOID  &&  (this.props.type !== MUNDIALSOCCERMATCHER) && this.props.type !==  MUNDIALPLAYERS) {
            if (props.data && props.data.ads === 'app_behaviour') {
                this.linkTo = props.data.href;
            } else {
                this.linkTo = CardHelper.getUri(
                    props.href,
                    props.group_id,
                    props.data,
                    props.ignoreSeenLast
                );
            }
            this.linkTo = this.linkTo.indexOf('/') > 0 ? `/${this.linkTo}` : this.linkTo;
        } else if(this.props.type === MUNDIALSOCCERMATCHER || this.props.type ===  MUNDIALPLAYERS){
            this.linkTo = props.href;
        }
    }

    onFocus() {
        if (
            (this.props.type === CLASSIC ||
                this.props.type === RECORDINGS ||
                this.props.type === LIVECHANNEL) &&
            !this.state.showActions
        ) {
            this.setState({ showActions: true });
        }
    }

    onBlur() {
        if (
            (this.props.type === CLASSIC ||
                this.props.type === RECORDINGS ||
                this.props.type === LIVECHANNEL) &&
            this.state.showActions
        ) {
            if (Utils.isModalHide() || Utils.modalType() === MODAL_RECORD_SERIES_CONTENT) {
                this.setState({ showActions: false });
            }
        }
    }

    handleOnClick = (e) => {
      const {data, title} = this.props;
      const {href} = data;
      const isMundial = href ? href.includes('mundial2022_partidos') : false;

      isMundial && sendGAEvent({
        hitType: 'event',
        eventCategory: 'carruseles inicio',
        eventAction: 'superdestacados',
        eventLabel: title
      });

      this.onClick(e);
      this.sendGA4Metric();
    }

    sendGA4Metric(){
        let content_list = "", content_name = "";
        const {data, data: {group_id, format_types, provider}, title, ribbonName} = this.props;
        const content_section = this.getContentSection();

        if (content_section === CONTENT_SECTION_SUBCATEGORY_TALEN) {
            content_list = title; //Nombre del Talento
            content_name = data.content_name; //Nombre de la Pelicula

        } else {
            content_list = ribbonName || '';
            content_name = title;
        }

        const gA4 = new GA4();
        const content_id = group_id;
        const content_type = this.getContentType(data);
        const content_category = '';
        const content_availability = getContentAvailability(format_types, provider);
        gA4.sendSelectContentEvent(content_section, content_list, content_id, content_name, content_type, content_category, content_availability);
    }

    getAppBehaviourLayOut(app_behaviour){
        let returnValue = false;
        try {
            const parsedData = JSON.parse(app_behaviour);
            if (parsedData && parsedData.layout !== undefined && parsedData.layout !== null) {
                returnValue = parsedData.layout;
            }
        } catch (ex) {
            console.error(ex);
        }
        finally{
            return returnValue;
        }
    }

    getContentSection(){
        const ADDON_LAYOUT = 'playandgo';
        let node = {};
        const pathItems = window.location.pathname.split('/');
        if (pathItems.length>0){
            node = pathItems.pop();
            node = getNavDataNodeByCode(node)
        }
        if (node){
            const {text, level, app_behaviour} = node;
            let appBehaviour = this.getAppBehaviourLayOut(app_behaviour)
            if (level === 1) {
                return `home ${text}`;
            }
            if (level === 2){
                if (appBehaviour){
                    const layout = typeof appBehaviour === 'string'
                                ? appBehaviour || ''
                                : appBehaviour.layout || '';
                    if (layout === ADDON_LAYOUT){
                        return CONTENT_SECTION_ADDON;
                    } else {
                        return CONTENT_SECTION_SUBCATEGORY;
                    }
                } else {
                    return CONTENT_SECTION_SUBCATEGORY;
                }
            }
            if (level===3) {
                const parent = getNavDataNodeById(node.id_parent);
                const {app_behaviour}  = parent;
                appBehaviour = this.getAppBehaviourLayOut(app_behaviour);
                const layout = typeof appBehaviour === 'string'
                                ? appBehaviour || ''
                                : appBehaviour.layout || '';
                if (layout === ADDON_LAYOUT){
                    return CONTENT_SECTION_ADDON_SUBCATEGORY;
                } else {
                    return CONTENT_SECTION_SUBCATEGORY;
                }
            }
        } else {
            const { navbar:{from: {ribbon_title = ''} = {}} = {} } = store.getState() || {};
            if (ribbon_title.toLowerCase && ribbon_title.toLowerCase() === 'talentos'){
                return CONTENT_SECTION_SUBCATEGORY_TALEN;
            }
            return CONTENT_SECTION_VCARD;
        }
    }

    getContentType(data){
        const {type, is_series} = data;
        if (type === "live") return CONTENT_TYPE_TV;
        if (is_series) return CONTENT_TYPE_SERIE;
        return CONTENT_TYPE_MOVIE;
    }

    getLinkEnvelope(cardComponent) {
        let className = '';
        if (this.props.ribbonIndex === 0) {
            className = 'elementopredeterminado';
        }
        const classDisplay = this.props.display && this.props.display === MODAL_TALENT_CONTENTS ? 'modal-talent-contents' : '';
        return (
            <FakeLink
                onClick={(e) => {this.handleOnClick(e)}}
                typeRender={this.typeRender}
                id={`link-${this.id}`}
                to={this.linkTo}
                className={`link-${this.props.type} link ${this.focusClassName} ${className} ${this.zoomEfectClassName} ${this.getClassNumberTop()} ${classDisplay}`}
                data-counter={this.state.positionInfinite}
                data-sn-up={this.focusUp}
                data-sn-down={this.focusDown}
                data-sn-right={this.focusRight}
                data-sn-left={this.focusLeft}
                onFocus={() => {
                    CardHelper.focusHandler(this.focusHandler, this.data);
                    this.onFocus();
                }}
                onKeyDown={(e) => CardHelper.keyDownHandler(e, this.keyDownHandler, this.data)}
                onBlur={this.onBlur}
            >
                {cardComponent}
            </FakeLink>
        );
    }

    getLinkPlayer(cardComponent) {
        let className = '';
        if (this.props.ribbonIndex === 0) {
            className = 'elementopredeterminado';
        }
        return (
            <FakeLink
                onClick={(e) => {
                    this.onClick(e);
                }}
                typeRender={this.typeRender}
                id={`link-${this.id}`}
                to={this.linkTo}
                className={`link-${this.props.type} link ${this.focusClassName} ${className} ${this.zoomEfectClassName} ${this.getClassNumberTop()}`}
                data-counter={this.state.positionInfinite}
                data-sn-up={this.focusUp}
                data-sn-right={this.focusRight}
                data-sn-left={this.focusLeft}
                onFocus={() => {
                    CardHelper.focusHandler(this.focusHandler, this.data);
                    this.onFocus();
                }}
                onKeyDown={(e) => CardHelper.keyDownHandler(e, this.keyDownHandler, this.data)}
                onBlur={this.onBlur}
            >
                {cardComponent}
            </FakeLink>
        );
    }

    infiniteCardEnvelope(cardComponent) {
        const classDisplay = this.props.display && this.props.display === MODAL_TALENT_CONTENTS ? 'modal-talent-contents' : '';

        return (
            <div id={this.id} className={`${this.props.type} ${classDisplay}`} ref={this.onLoadHandler}>
                {cardComponent}
            </div>
        );
    }

    getClassNumberTop() {
        const { data } = this.props;
        const valuesText = {
          0: `numberTop-one`,
          9: `numberTop-ten`
        };
        const valueIndex = `${data.index}`;
        const defaultText = `container-img-number`;
        let className = "";

        const arrayAux = Object.entries(valuesText);

        arrayAux.forEach(([key, value]) => {
          if (valueIndex === key) {
            className = value;
          }
        })

        return className === "" ? defaultText : className;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.positionInfinite !== this.state.positionInfinite) {
            this.init(nextProps);
            this.setState({
                positionInfinite: nextProps.positionInfinite,
            });
        }
    }

    render() {
        let cardComponent;
        switch (this.props.type) {
            case HIGHLIGHT:
                cardComponent = (
                    <CardHighlight
                        title={this.props.title}
                        label={this.props.label}
                        cover={this.props.cover}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                    />
                );
                break;
            case PREMIUM:
                cardComponent = (
                    <CardPremium
                        title={this.props.title}
                        label={this.props.label}
                        cover={this.props.cover}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                        bookmark={this.props.bookmark}
                        hasPlayerIcon={true}
                    />
                );
                break;
            case TALENTS:
                cardComponent = (
                    <CardTalents
                        content_name ={this.props.content_name}
                        title={this.props.text_highlight}
                        subtitle={this.props.group_name}
                        label={this.props.label}
                        cover={this.props.image_highlight}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                    />
                );
                break;
            case MUNDIALSOCCERMATCHER:

                cardComponent = (
                    <CardMatches
                        scheduledStartTimeUTC={changeDateToUserRegion(this.props.data.dateAndTimeInfo.scheduledStartTimeUTC)}
                        hpFlag={this.props.data.homeParticipant.nationality.images.flag}
                        hpCountryName= {this.props.data.homeParticipant.names.default}
                        apFlag= {this.props.data.awayParticipant.nationality.images.flag}
                        apCountryName = {this.props.data.awayParticipant.names.default}
                        currentPeriod = {this.props.data.state.currentPeriod}
                        scheduleStatus = {this.props.data.state.scheduleStatus}
                    />
                );
                break;
            case MUNDIALPLAYERS:
                cardComponent = (
                    <CardPlayer
                    image = {this.props.data.image}
                    name =  {this.props.data.name}
                    changeWeight={this.changeFontWeight}
                    />
                );
                break;
            case RECORDINGS:
                cardComponent = (
                    <CardRecording
                        title={this.props.title}
                        label={this.props.label}
                        cover={this.props.cover}
                        data={this.props.data}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                        showActions={this.state.showActions}
                        isRecentActivity={this.props.isRecentActivity}
                    />
                );
                break;
            case MOREPOPULAR:
                cardComponent = (
                    <CardMorePopular
                        title={this.props.title}
                        label={this.props.label}
                        portrait={this.props.portrait}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                    />
                );
                break;
            case MORETOP:
                cardComponent = (
                    <CardTop
                        title={this.props.title}
                        label={this.props.label}
                        cover={this.props.cover}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                        imageNumbersTop={this.props.imageNumbersTop}
                        classNumberTop={this.getClassNumberTop()}
                    />
                );
                break;
            case LIVECHANNEL:
                cardComponent = (
                    <CardLiveChannel
                        id={this.id}
                        title={this.props.title}
                        cover={this.props.cover}
                        hasPlayerIcon={true}
                        data={this.props.data}
                        bookmark={this.props.bookmark}
                        showActions={this.state.showActions}
                    />
                );
                break;
            case INFINITE:
                this.typeRender =
                    Utils.isNotNullOrNotUndefined(this.props.live_enabled) &&
                    parseInt(this.props.live_enabled) === 1
                        ? 'a'
                        : null;
                cardComponent = (
                    <CardInfinite
                        title={this.props.title}
                        label={this.props.label}
                        cover={this.props.cover}
                        showTitles={!this.props.hideTitles}
                        badges={this.props.badges}
                        provider={this.props.provider || null}
                        live_enabled={this.props.live_enabled || null}
                    />
                );
                break;
            case VOID:
                cardComponent = <CardVoid placeholder={this.props.placeholder}/>;
                break;
            case CLASSIC:
            default:
                const { ribbonType = '' } = this.props;
                cardComponent = (
                    <CardView
                        ribbonType={ribbonType}
                        id={this.id}
                        title={this.props.title}
                        label={this.props.label}
                        cover={this.props.cover}
                        bookmark={this.props.bookmark}
                        showTitles={!this.props.hideTitles}
                        isRecentActivity={this.props.isRecentActivity}
                        badges={this.props.badges}
                        onDeleteAction={this.deleteAction}
                        showActions={this.state.showActions}
                        data={this.data}
                    />
                );
        }
        cardComponent =
            this.props.type !== VOID ? this.getLinkEnvelope(cardComponent) : cardComponent;
        if (this.props.type === INFINITE) {
            cardComponent = this.infiniteCardEnvelope(cardComponent);
        }
        if(this.props.type ===  MUNDIALPLAYERS){
            cardComponent = this.getLinkPlayer(cardComponent);
        }
        return cardComponent;
    }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/CardNew/index.jsx